import React from 'react';
import {
  Image, Text, View,
} from 'react-native';
import {
  img_android_screen_share_dialog,
} from '../../../../../utils/ImagesManagementUtils';
import { getRef, LocStr } from '../../../../../utils/Utils';

const TransferSuccessShareDialogFP = ({
  topTitle,
  globJSON,
  language,
  slideshowRefs,
}) => {
  const myStyles = {
    lblPhoneTitle: {
      fontFamily: 'Quicksand-SemiBold',
      fontSize: 16,
      color: '#001a2f',
    },
    phoneImage: {
      width: 240,
      height: 427,
      backgroundColor: globJSON.configurations.theme.colors.app_background_color,
    },
  };
  //= ====================================================================
  return (
    <View ref={getRef(slideshowRefs)}>
      <Text style={myStyles.lblPhoneTitle}>
        {LocStr(topTitle, language)}
      </Text>
      <Image
        fadeDuration={0}
        style={myStyles.phoneImage}
        source={img_android_screen_share_dialog}
      />
    </View>

  );
};

export default TransferSuccessShareDialogFP;
